import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { formatRelativeTime } from "../../../utils/formatTime";
import ListNoti from "../../../assets/components/ListNoti";
import error from "../../../assets/icons/System/error.svg";

const AdsNoticeList = ({
    notices,
    storeBusinessNumber,
    type,
    fromTab: propFromTab,
    userId,
    isLoaded,
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const resolvedFromTab = location.state?.fromTab ?? propFromTab ?? "home";

    const [readSet, setReadSet] = useState(new Set()); // 방금 읽은 항목들
    const [unreadSet, setUnreadSet] = useState(new Set()); // 서버 기준 "미읽음" notice_no 집합

    // 최초 미읽음 정보 로드
    useEffect(() => {
        (async () => {
            try {
                const uid = userId || localStorage.getItem("user_id");
                if (!uid) return;
                const res = await axios.get(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/get/notice/check/read`,
                    { params: { user_id: uid } }
                );
                const ids = (res.data?.unread_notices ?? res.data ?? []).map(
                    (n) => Number(n.notice_no ?? n)
                );
                setUnreadSet(new Set(ids));
            } catch (e) {
                console.error("미읽음 조회 실패:", e);
            }
        })();
    }, [userId]);

    // 제목 클릭 → 즉시 읽음 표시 + 서버 기록 + 상세 이동
    const handleNoticeClick = (notice) => {
        const id = Number(notice.notice_no);

        // 1) UI 즉시 반영
        setReadSet((prev) => new Set(prev).add(id));
        setUnreadSet((prev) => {
            const next = new Set(prev);
            next.delete(id);
            return next;
        });

        // 2) 서버에 읽음 기록
        const uid = userId || localStorage.getItem("user_id");
        if (uid) {
            axios
                .post(
                    `${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/notice/read`,
                    {
                        user_id: uid,
                        notice_no: id,
                    }
                )
                .catch((e) => {
                    console.error("읽음 처리 실패:", e);
                });
        }
        // 3) 상세 페이지로 이동
        navigate(`/ads/notice/${notice.notice_no}`, {
            state: {
                notice,
                storeBusinessNumber,
                type,
                fromTab: resolvedFromTab,
                source: "notice"
            }, // 공지사항 정보를 state로 전달
        });
    };

    return (
        <div className="overflow-hidden">
            {!isLoaded ? null :
                !notices || notices.length === 0 ? (
                    <div className="flex flex-col items-center justify-center pt-[220px]">
                        <img src={error} alt="error" />
                        <p className="text-b2 text-text-subtler text-center pt-[16px]">
                            공지사항이 없어요
                        </p>
                    </div>
                ) : (
                    <ul className="space-y-[8px]">
                        {notices.map((notice) => {
                            const id = Number(notice.notice_no);
                            const isRead = readSet.has(id) || !unreadSet.has(id); // 서버 기준 + 로컬 클릭 반영
                            const isUnread = !isRead;
                            // const isUnread = unreadNoticeNos.includes(notice.notice_no);

                            return (
                                <ListNoti
                                    key={notice.notice_no}
                                    notice={notice}
                                    isUnread={isUnread}
                                    onClick={handleNoticeClick}
                                    formatRelativeTime={formatRelativeTime}
                                />
                            );
                        })}
                    </ul>
                )}
        </div>
    );
};

export default AdsNoticeList;
